import React, { Suspense } from 'react';
import { ModuleConfig } from '../types/config';
import { ModuleErrorBoundary } from './ModuleErrorBoundary';

interface DynamicComponentProps {
  moduleConfig: ModuleConfig;
  data?: any;
}

const componentRegistry: Record<string, React.ComponentType<any>> = {};

export const registerComponent = (name: string, component: React.ComponentType<any>) => {
  componentRegistry[name] = component;
};

function ModuleLoadFallback() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-sm text-gray-500">Loading module…</div>
    </div>
  );
}

export const DynamicComponent: React.FC<DynamicComponentProps> = ({ moduleConfig, data }) => {
  const Component = componentRegistry[moduleConfig.component];

  if (!Component) {
    return (
      <div className="flex items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Component Not Found</h3>
          <p className="text-gray-600">
            The component "{moduleConfig.component}" is not registered.
          </p>
        </div>
      </div>
    );
  }

  return (
    <ModuleErrorBoundary moduleName={moduleConfig.name || moduleConfig.component}>
      <Suspense fallback={<ModuleLoadFallback />}>
        <Component config={moduleConfig} data={data} />
      </Suspense>
    </ModuleErrorBoundary>
  );
};
